var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "swatches-view swatches-view-wrapper",
    attrs: {
      "aria-labelledby": "customs-component-navigation",
      "role": "tabpanel",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "screen-reader-only",
    attrs: {
      "id": "customs-announcer",
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_vm._v(" " + _vm._s(_vm.announcerText))]), _c('div', {
    staticClass: "swatches-view-header",
    on: {
      "click": function click($event) {
        return _vm.hideSplashPage();
      }
    }
  }, [_vm._t("buybutton"), _c('div', {
    staticClass: "swatches-view-header-wrapper"
  }, [_vm._t("navigation")], 2), _c('tabs')], 2), _vm._l(_vm.getTabsSwatches, function (groupsToRender, name) {
    return _c('swatches-wrapper', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.activeLibraryOption && !_vm.activeUGCOption && _vm.activeGroup === name && _vm.activeGroup !== 'yourcolors',
        expression: "!activeLibraryOption && !activeUGCOption && activeGroup === name && activeGroup !== 'yourcolors'"
      }],
      key: name,
      class: [name + '-container'],
      attrs: {
        "swatchesToRender": groupsToRender.subgroups,
        "groupName": name,
        "activeGroup": _vm.activeGroup
      },
      on: {
        "click": function click($event) {
          return _vm.hideSplashPage();
        }
      }
    });
  }), _vm.isComponentUGCEnabled || _vm.isComponentLibraryEnabled || _vm.configuration.vct_settings.pattern_maker.enabled || this.configuration.vct_settings.custom_checkerboard.enabled ? [_c('ugc-tray-wrapper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeOption,
      expression: "activeOption"
    }],
    attrs: {
      "init": _vm.activeOption
    }
  })] : _vm._e(), _vm.getGroupTabs['yourcolors'] ? _c('pick-your-own-color-tray', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeGroup === 'yourcolors',
      expression: "activeGroup === 'yourcolors'"
    }]
  }) : _vm._e(), _c('palettes'), _c('palette-modal'), _c('feature-tab-modal')], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }